import type { CartItemVM } from 'types/view-models';

type ProductOptionsShape = {
  options?: Array<{ values?: unknown[] | null }> | null;
};

export const isSimpleProduct = (product: ProductOptionsShape): boolean => {
  return (
    product.options?.length === 1 && product.options[0].values?.length === 1
  );
};

export const getVariantTitle = (
  variant: { title?: string | null } | undefined,
): string | null => {
  if (!variant?.title || variant.title.toLowerCase() === 'default') {
    return null;
  }
  return variant.title;
};

/**
 * Returns the display title for a line item, combining product title and
 * variant title when the variant has a meaningful name.
 */
export const getLineItemTitle = (
  item: Pick<CartItemVM, 'product_title' | 'variant'>,
): string | null | undefined => {
  const variantTitle = getVariantTitle(item.variant ?? undefined);
  return variantTitle
    ? `${item.product_title}, ${variantTitle}`
    : item.product_title;
};
